// ── AttendanceSection 스타일 상수 (Tailwind 클래스 문자열) ────────────────────
// CSS-in-JS → Tailwind + dark mode 클래스로 전환
// 동적 분기가 필요한 항목은 파라미터를 받는 함수로 제공

// ── 레이아웃 ──────────────────────────────────────────────────────────────────
/** 전체 스택 레이아웃 */
export const stackClass = 'grid gap-3';

/** 섹션 카드 */
export const cardClass =
  'bg-white dark:bg-[var(--bg-card)] rounded-xl shadow-card border border-[var(--border)] p-4 w-full min-w-0';

// ── 섹션 헤더 ─────────────────────────────────────────────────────────────────
/** 섹션 제목 */
export const sectionTitleClass =
  'mt-0 mb-3.5 text-[15px] font-extrabold text-[var(--text)] tracking-tight';

/** 섹션 상단 헤더 행 */
export const sectionTopRowClass =
  'flex justify-between items-center gap-2 flex-wrap mb-2';

/** 필터 행 */
export const filterRowClass = 'flex gap-2 flex-wrap';

// ── IP/위치 정보 그리드 ────────────────────────────────────────────────────────
/** 레이블+값 테이블형 그리드 */
export const infoGridClass =
  'grid border border-[var(--border)] rounded-xl overflow-hidden mb-3';

/** 그리드 각 행 */
export const infoRowClass =
  'grid items-center px-3 py-2 border-b border-[var(--border)] text-[13px] last:border-b-0';
export const infoRowStyle = { gridTemplateColumns: '80px 1fr' }; // 동적 grid-cols inline 유지

/** IP 정보 셀 스타일 */
export const infoLabelClass =
  'font-bold text-[var(--text-muted)] text-[11px] tracking-[0.3px] uppercase';
export const infoValueCodeClass =
  'text-[12px] text-[var(--text)] overflow-wrap-anywhere break-all font-mono';
export const infoValueClass =
  'text-[13px] text-[var(--text-sub)] overflow-wrap-anywhere break-words';

// ── IP 상태 / 버튼 / 경고 ─────────────────────────────────────────────────────
/** IP 허용/불허 상태 클래스 반환 */
export const ipStatusClass = (allowed) =>
  `text-[12px] font-bold ${allowed ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`;

/** 위치 권한 요청 버튼 */
export const locationBtnClass =
  'border border-[var(--border)] rounded-lg px-3.5 py-2 font-semibold cursor-pointer bg-[var(--bg-subtle)] text-[var(--text-sub)] text-[13px] mb-2 hover:bg-[var(--border)] transition-colors';

/** 경고 박스 */
export const warningBoxClass =
  'mt-2 mb-1 border border-red-200 dark:border-red-800/50 bg-red-50 dark:bg-red-950/30 rounded-xl p-2.5';
export const warningTitleClass =
  'text-red-800 dark:text-red-400 font-bold mb-1.5 text-[13px]';
export const warningLineClass =
  'text-red-800 dark:text-red-400 text-[13px] overflow-wrap-anywhere break-words';

// ── 근무 상태 / 버튼 ──────────────────────────────────────────────────────────
/** 현재 근무 상태 뱃지 클래스 반환 */
export const statusBadgeClass = (today) => {
  if (today?.checked_out)
    return 'inline-block mt-2.5 mb-1 px-3 py-1.5 rounded-full text-[13px] font-bold bg-green-50 dark:bg-green-950/30 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-800/50';
  if (today?.checked_in)
    return 'inline-block mt-2.5 mb-1 px-3 py-1.5 rounded-full text-[13px] font-bold bg-blue-50 dark:bg-blue-950/30 text-blue-700 dark:text-blue-400 border border-blue-200 dark:border-blue-800/50';
  return 'inline-block mt-2.5 mb-1 px-3 py-1.5 rounded-full text-[13px] font-bold bg-[var(--bg-subtle)] text-[var(--text-muted)] border border-[var(--border)]';
};

/** 출근 버튼 (녹색) */
export const checkInBtnClass =
  'block w-full border-0 text-white rounded-xl px-3.5 py-3.5 font-bold cursor-pointer mt-2.5 text-[15px] tracking-tight transition-colors bg-green-500 hover:bg-green-600 active:bg-green-700 disabled:bg-slate-400 dark:disabled:bg-slate-600 disabled:cursor-not-allowed';

/** 퇴근 버튼 (빨간) */
export const checkOutBtnClass =
  'block w-full border-0 text-white rounded-xl px-3.5 py-3.5 font-bold cursor-pointer mt-2.5 text-[15px] tracking-tight transition-colors bg-red-500 hover:bg-red-600 active:bg-red-700 disabled:bg-slate-400 dark:disabled:bg-slate-600 disabled:cursor-not-allowed';

/** 근무 완료 박스 */
export const doneBoxClass =
  'mt-2.5 border border-green-200 dark:border-green-800/50 bg-green-50 dark:bg-green-950/30 rounded-xl p-2.5 text-green-800 dark:text-green-400 font-bold text-[13px]';

// ── 2026-09-14 레이아웃 개편 (사용자 첨부 시안) ───────────────────────────────
// 윗부분을 "카드 안의 표" 에서 **액션 줄 + 정보 카드 + 위치 박스** 로 나눴다.
//   · 출근/퇴근 버튼을 맨 위로 올려 한 번에 보이게 (전에는 경고문 아래 맨 끝이었다)
//   · 등록 IP 는 버튼 옆 알약으로 — 늘 같은 값이라 표 한 줄을 차지할 이유가 없다
//   · "출퇴근 체크" 제목과 카드 테두리는 뺐다. 페이지 제목이 이미 그 말을 한다.

// ── 2026-09-14 2차 시안: 상단을 한 장의 카드로 ────────────────────────────────
//   [프로필 아이콘 이름 / 부서·근무유형·등록IP]  |  [현재IP · IP상태]  |  [출근하기]
/** 상단 카드 */
export const topCardClass =
  'border border-[var(--border)] rounded-2xl bg-[var(--bg-card)] px-5 py-4 mb-3'
  // 모바일은 세로로 쌓는다 (2026-09-14 사용자 지시) — 가로로 두면 칸이 너무 좁아진다.
  + ' flex flex-col md:flex-row items-stretch gap-4';

/** 좌: 프로필 아이콘 + 이름/메타 */
// 이름 블록과 IP 블록이 남는 폭을 **반씩** 나눈다 (2026-09-14 3차 시안).
//   처음엔 이름 블록에 flex-1 만 있어 IP 가 오른쪽 끝까지 밀렸고,
//   그 다음 shrink 로만 두니 IP 가 이번엔 왼쪽으로 붙었다.
export const idBlockClass = 'flex items-center gap-3.5 min-w-0 md:flex-1 md:basis-0 md:pr-2';
export const avatarClass =
  'w-12 h-12 rounded-xl bg-white dark:bg-[var(--bg-subtle)] border border-[var(--border)]'
  + ' flex items-center justify-center shrink-0 overflow-hidden';
export const avatarImgClass = 'w-9 h-9 object-contain';
export const avatarTextClass = 'text-pine-700 dark:text-[var(--text)] font-black text-[18px] leading-none';
export const nameClass = 'text-[19px] font-extrabold text-[var(--text)] leading-tight truncate';
// 모바일: 부서·근무유형·등록 IP 를 한 줄씩 (구분선 '|' 은 가로일 때만)
export const metaRowClass =
  'flex flex-col items-start gap-0.5 md:flex-row md:items-center md:gap-2 md:flex-wrap'
  + ' text-[12.5px] text-[var(--text-muted)] mt-1';
export const metaSepClass = 'hidden md:inline text-[var(--border)] select-none';

/** 가운데: 현재 IP / IP 상태 (세로 구분선) */
export const ipBlockClass =
  'flex flex-col justify-center gap-1.5 min-w-0 md:flex-1 md:basis-0'
  // 모바일에선 위에 가로선, 가로에선 왼쪽에 세로선 (사용자가 말한 '라인')
  + ' border-t border-[var(--border)] pt-3.5'
  + ' md:border-t-0 md:pt-0 md:border-l md:border-[var(--border)] md:pl-7';
export const ipLineClass = 'flex items-baseline gap-3 min-w-0';
// 라벨 폭은 가장 긴 라벨("현재 위치" 5글자)에 맞춘다 — 세 줄의 값이 나란히 서야 한다.
export const ipLabelClass = 'text-[12px] text-[var(--text-muted)] w-[62px] shrink-0';
export const ipValueClass = 'text-[13.5px] font-bold text-[var(--text)] break-all';
// 주소는 IP 와 달리 **단어 단위**로 줄바꿈한다(`break-all` 은 글자 중간을 자른다).
export const locAddrClass = 'text-[13.5px] font-bold text-[var(--text)] break-words min-w-0';

/** 우: 출근/퇴근 버튼 자리 */
// 버튼 앞에도 구분선을 둔다 (시안) — 전에는 IP 블록과 버튼 사이가 비어 있었다.
// 모바일에선 버튼이 가로로 꽉 찬다 (actionBtnClass 의 w-full) — 손가락으로 누르는 화면이라.
export const ctaBlockClass =
  'shrink-0 flex items-center md:border-l md:border-[var(--border)] md:pl-7';

/** 더보기 버튼 */
export const moreBtnClass =
  'w-full border border-[var(--border)] rounded-xl py-3 mt-2 text-[13px] font-bold cursor-pointer'
  + ' bg-[var(--bg-card)] text-[var(--text-sub)] hover:bg-[var(--bg-subtle)] transition-colors';

/** 맨 윗줄 — 등록 IP 알약 + 출근/퇴근 버튼 */
export const actionRowClass = 'flex items-center gap-3 flex-wrap mb-4';

/** 등록 IP 알약 */
export const regIpPillClass =
  'flex items-center gap-2.5 border border-[var(--border)] rounded-xl pl-1.5 pr-4 py-1.5 min-w-0 bg-[var(--bg-card)]';
export const regIpIconClass =
  'flex items-center justify-center w-9 h-9 rounded-lg bg-[var(--bg-subtle)] text-[var(--text-muted)] text-[15px] shrink-0';
export const regIpTextClass =
  'text-[13px] text-[var(--text-muted)] truncate';

/** 출근/퇴근 버튼 — designStandard 의 stdBlackBtn 과 같은 값 (2026-09-14 2차, 사용자 지시).
 *   #0f172a 배경 / 흰 글씨 / 라운드 12px. 다른 화면의 검정 버튼(예: 연차관리 "+ 연차추가")과 같다.
 *   다크 모드는 --std-btn(index.css .dark, 파랑) — stdBlackBtn 과 같은 변수를 쓴다 (2026-09-28). */
export const actionBtnClass =
  'w-full md:w-auto rounded-lg px-5 py-2.5 text-[14px] font-bold cursor-pointer transition-colors'
  + ' border border-[var(--std-btn,#0f172a)] bg-[var(--std-btn,#0f172a)] text-white hover:opacity-90'
  // ⚠ 비활성에서 **테두리까지** 바꿔야 한다. 안 하면 검정 테두리 + 회색 배경이 된다(사용자 신고).
  // 그리고 border-[var(--border)] 는 Tailwind 가 폭으로 읽을 수 있어 color: 를 명시한다.
  + ' disabled:bg-[color:var(--border)] disabled:border-[color:var(--border)]'
  + ' disabled:text-[color:var(--text-muted)] disabled:cursor-not-allowed';

/** 근무 완료 알약 (버튼 자리) */
export const doneePillClass =
  'rounded-lg px-4 py-2.5 text-[13px] font-bold border border-green-200 dark:border-green-800/50'
  + ' bg-green-50 dark:bg-green-950/30 text-green-700 dark:text-green-400';

/** 정보 카드 (현재 IP / IP 상태) */
export const infoCardClass =
  'border border-[var(--border)] rounded-xl overflow-hidden mb-2.5';

/** 현재 위치 박스 */
// ⚠ 이 빨간 박스는 **위치를 못 잡았을 때만** 뜼다 (사용자 지시 2026-09-14).
//   정상일 때의 주소는 상단 카드 안 '현재 위치' 줄로 간다.
export const locBoxClass =
  'border border-red-200 dark:border-red-800/50 bg-red-50 dark:bg-red-950/30'
  + ' rounded-xl px-4 py-3.5 grid gap-2.5';
export const locLineClass = 'flex items-baseline gap-3 flex-wrap text-[13px]';
export const locValueClass =
  'text-red-800 dark:text-red-400 font-bold overflow-wrap-anywhere break-words';
export const locHintRowClass = 'flex items-center gap-3 flex-wrap';
export const locHintClass =
  'text-[12px] text-red-800/80 dark:text-red-400/80 overflow-wrap-anywhere break-words';

/** 위치권한 동의 작은 버튼 */
export const locBtnSmallClass =
  'border border-red-200 dark:border-red-800/50 rounded-lg px-2.5 py-1.5 text-[11px] font-bold cursor-pointer shrink-0'
  + ' bg-white dark:bg-[var(--bg-card)] text-red-700 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-950/50 transition-colors'
  + ' disabled:opacity-60 disabled:cursor-not-allowed';

/** 기록 섹션 제목 줄 (카드 없이) */
export const recordHeadClass = 'flex justify-between items-center gap-2 flex-wrap mt-6 mb-3';
export const recordTitleClass = 'm-0 text-[17px] font-extrabold text-[var(--text)] tracking-tight';

/** 연/월 셀렉트 — 둥근 알약 */
export const selectPillClass =
  'border border-[var(--border)] rounded-full px-4 py-2 text-[13px] min-h-[36px] cursor-pointer'
  + ' bg-[var(--bg-subtle)] text-[var(--text)] focus:outline-none focus:ring-2 focus:ring-pine-900/20 dark:focus:ring-accent-500/20';

// ── 출퇴근 기록 목록 ──────────────────────────────────────────────────────────
/** 셀렉트/인풋 공통 스타일 */
export const inputClass =
  'border border-[var(--border)] rounded-lg px-2.5 py-2 text-[13px] min-h-[34px] max-w-full bg-[var(--bg-subtle)] text-[var(--text)] focus:outline-none focus:ring-2 focus:ring-pine-900/20 dark:focus:ring-accent-500/20';

export const listWrapClass = 'grid gap-1.5';
export const emptyTextClass =
  'text-[var(--text-muted)] py-3.5 text-[13px] text-center';

/** 출퇴근 기록 항목 래퍼 — opened 상태에 따라 배경 변경 */
export const itemWrapClass = (opened) =>
  `border border-[var(--border)] rounded-xl overflow-hidden ${
    opened
      ? 'bg-[var(--bg-subtle)] shadow-sm'
      : 'bg-white dark:bg-[var(--bg-card)]'
  }`;

export const itemBtnClass =
  'w-full border-0 bg-transparent text-left cursor-pointer px-3 py-2.5';
export const itemTopRowClass =
  'flex justify-between items-center gap-2 mb-2';
export const dateLabelRowClass =
  'inline-flex items-center gap-1.5 min-w-0 font-bold text-[var(--text)] text-[13px]';

/** 지각 표시 주황 점 */
export const lateDotClass =
  'w-2 h-2 rounded-full bg-orange-400 flex-shrink-0 ring-1 ring-orange-400/25';

/** '상세 보기/접기' 토글 레이블 */
export const toggleLabelClass = (opened) =>
  `text-[12px] font-bold ${opened ? 'text-pine-900 dark:text-accent-400' : 'text-[var(--text-muted)]'}`;

export const chipRowClass = 'flex flex-wrap gap-1.5 items-center';
export const chipClass =
  'inline-flex items-center h-[26px] px-2.5 rounded-full border border-[var(--border)] bg-[var(--bg-subtle)] text-[var(--text-sub)] font-semibold whitespace-nowrap tabular-nums text-[12px]';

// ── 상세 패널 ─────────────────────────────────────────────────────────────────
export const detailBoxClass =
  'border-t border-[var(--border)] px-3 py-2.5 grid gap-1.5 bg-[var(--bg-subtle)]';
export const detailLineClass =
  'text-[13px] text-[var(--text-sub)] overflow-wrap-anywhere break-words';

/** 휴게시간 편집 행 */
export const breakEditorRowClass =
  'grid gap-2 items-center';
export const breakEditorRowStyle = { gridTemplateColumns: '80px 1fr 64px' }; // 동적 grid-cols inline 유지
export const breakEditorLabelClass =
  'text-[12px] font-bold text-[var(--text-muted)]';
export const breakInputClass =
  'border border-[var(--border)] rounded-lg px-2.5 py-2 text-[13px] w-full bg-white dark:bg-[var(--bg-subtle)] text-[var(--text)] focus:outline-none focus:ring-2 focus:ring-pine-900/20 dark:focus:ring-accent-500/20';
export const miniSaveBtnClass =
  'border border-pine-900 dark:border-accent-500 bg-pine-900 dark:bg-accent-600 text-white rounded-lg h-8 text-[12px] font-bold cursor-pointer hover:bg-pine-800 dark:hover:bg-accent-500 transition-colors disabled:opacity-60 disabled:cursor-not-allowed';
export const detailHintClass =
  'text-[12px] text-[var(--text-muted)]';
